import type { SVGProps } from "react";

interface RegistryIconProps extends SVGProps<SVGSVGElement> {
  stroke?: string;
  className?: string;
  width?: number;
  height?: number;
}

const RegistryIcon: React.FC<RegistryIconProps> = ({ 
  stroke = "white", 
  className = "", 
  width = 16, 
  height = 16,
  ...props
}) => {
  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 16 16" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path 
        d="M2.6665 7.33325V9.99992C2.6665 12.1998 2.6665 13.2997 3.34992 13.9832C4.03334 14.6666 5.13328 14.6666 7.33317 14.6666H8.6665C10.8664 14.6666 11.9663 14.6666 12.6498 13.9832C13.3332 13.2997 13.3332 12.1998 13.3332 9.99992V7.33325" 
        stroke={stroke} 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      <path 
        d="M2 6.00008C2 5.50162 2 5.25239 2.13397 5.06675C2.22174 4.94513 2.34798 4.84414 2.5 4.77393C2.73205 4.66675 3.04359 4.66675 3.66667 4.66675H12.3333C12.9564 4.66675 13.2679 4.66675 13.5 4.77393C13.652 4.84414 13.7783 4.94513 13.866 5.06675C14 5.25239 14 5.50162 14 6.00008C14 6.49854 14 6.74775 13.866 6.93341C13.7783 7.05501 13.652 7.15601 13.5 7.22621C13.2679 7.33341 12.9564 7.33341 12.3333 7.33341H3.66667C3.04359 7.33341 2.73205 7.33341 2.5 7.22621C2.34798 7.15601 2.22174 7.05501 2.13397 6.93341C2 6.74775 2 6.49854 2 6.00008Z" 
        stroke={stroke} 
        strokeLinejoin="round"
      />
      <path 
        d="M4 2.52373C4 1.86625 4.53299 1.33325 5.19047 1.33325H5.42857C6.84873 1.33325 8 2.48452 8 3.90468V4.66659H6.14286C4.95939 4.66659 4 3.70719 4 2.52373Z" 
        stroke={stroke} 
        strokeLinejoin="round"
      />
      <path 
        d="M12 2.52373C12 1.86625 11.467 1.33325 10.8095 1.33325H10.5714C9.15127 1.33325 8 2.48452 8 3.90468V4.66659H9.85713C11.0406 4.66659 12 3.70719 12 2.52373Z" 
        stroke={stroke} 
        strokeLinejoin="round"
      />
      <path 
        d="M8 7.33325V14.6666" 
        stroke={stroke} 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default RegistryIcon; 